var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockedDistributors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.839,
    height: 35.839,
    viewBox: "0 0 35.839 35.839",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "product_distributor",
    "data-name": "product distributor",
    transform: "translate(0.502 0.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline",
    transform: "translate(-0.082 -0.083)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24244",
    "data-name": "Path 24244",
    d: "M31.755,6.221a3.152,3.152,0,1,0-2.488-1.232L25.228,9.028a11.423,11.423,0,0,0-7.4-3.07V3.995a2.048,2.048,0,1,0-.819,0V5.958a11.423,11.423,0,0,0-7.4,3.07L5.569,4.989a3.152,3.152,0,1,0-.579.579L9.029,9.607a11.424,11.424,0,0,0-3.07,7.4H4a2.048,2.048,0,1,0,0,.819H5.959a11.424,11.424,0,0,0,3.07,7.4L4.99,29.266a3.152,3.152,0,1,0,.579.579l4.039-4.039a11.423,11.423,0,0,0,7.4,3.07V30.84a2.048,2.048,0,1,0,.819,0V28.876a11.423,11.423,0,0,0,7.4-3.07l4.039,4.039a3.152,3.152,0,1,0,.579-.579l-4.039-4.039a11.424,11.424,0,0,0,3.07-7.4H30.84a2.048,2.048,0,1,0,0-.819H28.877a11.424,11.424,0,0,0-3.07-7.4l4.039-4.039a3.12,3.12,0,0,0,1.909.653ZM3.081,5.4A2.321,2.321,0,1,1,5.4,3.08,2.321,2.321,0,0,1,3.081,5.4ZM1.988,18.646a1.229,1.229,0,1,1,1.229-1.229A1.229,1.229,0,0,1,1.988,18.646ZM3.081,34.075A2.321,2.321,0,1,1,5.4,31.754,2.321,2.321,0,0,1,3.081,34.075Zm28.674-4.642a2.321,2.321,0,1,1-2.321,2.321A2.321,2.321,0,0,1,31.755,29.433Zm1.092-13.245a1.229,1.229,0,1,1-1.229,1.229,1.229,1.229,0,0,1,1.229-1.229ZM16.189,1.988a1.229,1.229,0,1,1,1.229,1.229,1.229,1.229,0,0,1-1.229-1.229Zm2.458,30.858a1.229,1.229,0,1,1-1.229-1.229,1.229,1.229,0,0,1,1.229,1.229Zm9.421-15.429a10.65,10.65,0,1,1-10.65-10.65,10.65,10.65,0,0,1,10.65,10.65ZM31.755.759A2.321,2.321,0,1,1,29.433,3.08,2.321,2.321,0,0,1,31.755.759Z",
    transform: "translate(0.082 0.083)",
    fill: "#d34646",
    stroke: "#d34646",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24245",
    "data-name": "Path 24245",
    d: "M51.261,41H42.543A2.045,2.045,0,0,0,40.5,43.043v8.445a2.045,2.045,0,0,0,2.043,2.043h8.717A2.045,2.045,0,0,0,53.3,51.488V43.043A2.045,2.045,0,0,0,51.261,41Zm-5.857.817h3v2.557l-1.015-.745a.813.813,0,0,0-.967,0l-1.015.746Zm7.083,9.671a1.227,1.227,0,0,1-1.226,1.226H42.543a1.227,1.227,0,0,1-1.226-1.226V43.043a1.227,1.227,0,0,1,1.226-1.226h2.043v2.557a.817.817,0,0,0,1.3.657l1.015-.744,1.014.744a.817.817,0,0,0,1.3-.657V41.817h2.043a1.227,1.227,0,0,1,1.226,1.226Z",
    transform: "translate(-29.402 -29.766)",
    fill: "#d34646",
    stroke: "#d34646",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24246",
    "data-name": "Path 24246",
    d: "M55.626,73.635H53.447a.409.409,0,1,0,0,.817h2.179a.409.409,0,1,0,0-.817Zm0-1.635H53.447a.409.409,0,0,0,0,.817h2.179a.409.409,0,0,0,0-.817ZM49.36,72H47.181a.681.681,0,0,0-.681.681v1.09a.681.681,0,0,0,.681.681H49.36a.681.681,0,0,0,.681-.681v-1.09A.681.681,0,0,0,49.36,72Zm-.136,1.635H47.317v-.817h1.907Z",
    transform: "translate(-33.768 -52.312)",
    fill: "#d34646",
    stroke: "#d34646",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockedDistributors);
export default __webpack_public_path__ + "static/media/blockedDistributors.d0e31c72ca96677f3e35d2f5d012a952.svg";
export { ForwardRef as ReactComponent };